import { ReportBlockProps } from '@va/types/report-block';
import { PropsWithChildren, forwardRef, memo } from 'react';
import { ReportBlockProvider } from './report-block-ctx';
import { ReportBlockHeaderProvider } from './report-block-header-ctx';
import { ReportBlockBody, ReportBlockBodyProps } from './ReportBlockBody';
import { ReportBlockDataComponent } from './ReportBlockDataComponent';
import { ReportBlockDisabledOverlay } from './ReportBlockDisabledOverlay';
import { ReportBlockHeader, ReportBlockSubHeader } from './ReportBlockHeader';

export const ReportBlock = memo(
  forwardRef<HTMLDivElement, PropsWithChildren<ReportBlockProps & ReportBlockBodyProps>>(
    ({ className, border, disabled, ...props }, ref) => {
      return (
        <ReportBlockProvider {...props}>
          <ReportBlockBody className={className} border={border} ref={ref}>
            {props.nodes?.exportSummary}
            <ReportBlockHeaderProvider>
              <ReportBlockHeader />
              <ReportBlockSubHeader />
            </ReportBlockHeaderProvider>
            <ReportBlockDataComponent />
            {disabled && <ReportBlockDisabledOverlay content={typeof disabled === 'boolean' ? undefined : disabled} />}
          </ReportBlockBody>
        </ReportBlockProvider>
      );
    },
  ),
);
